import React, { useEffect, useState } from 'react';

//cpds
import { Cpds } from '@Cpds.Ui';

//helpers
import { checkValue, capitalizeFirst } from 'src/components/common/helper';
import { ThemeColorMode } from 'src/components/common/cpds/utils/cpds-utils';
import { getStore } from 'src/utils/store-utils';

export type crumbs = {
  name: string;
  url?: string;
  target?: string;
  active?: boolean;
};

export interface V3BreadcrumbModuleProps {
  theme?: ThemeColorMode;
  pageSeoData?: any;
  mccidData?: any;
  clickstreamData?: any;
}

const V3BreadcrumbModule: React.FC<V3BreadcrumbModuleProps> = (props) => {
  const { theme, pageSeoData, clickstreamData } = props;

  const [crumbs, setCrumbs] = useState<crumbs[]>([]);

  const {
    turnOffSubheader,
    breadcrumbCurrentCopy,
    breadcrumbHomeCopy,
    breadcrumbParentCopy,
    breadcrumbParentUrl,
    isMiddleLayerEnabled,
    breadcrumbHomeUrl,
    breadcrumb,
  } = getStore();

  const isGoGuiedBC = checkValue(breadcrumb) && breadcrumb.length > 0 ? true : false;

  if (turnOffSubheader === 'True') return null;

  //create crumbs
  const getBreadcrumbs = () => {
    let items = [];

    if(checkValue(breadcrumb) && breadcrumb.length >= 0){
      breadcrumb.map((item: any) => {
        items.push({
          active: false,
          name: item?.title,
          url: checkValue(item?.url) ? item?.url : '#',
          target: item?.ctaOpenNewTab ? '_blank' : '_self',
        });
      });
    } else {
      items.push({
        active: false,
        name: checkValue(breadcrumbHomeCopy) ? breadcrumbHomeCopy : 'Home',
        url: checkValue(breadcrumbHomeUrl)
          ? breadcrumbHomeUrl
          : '/' + pageSeoData?.partner + '/' + pageSeoData?.templateName,
      });
      if (isMiddleLayerEnabled === 'True' && checkValue(breadcrumbParentCopy)) {
        items.push({
          active: false,
          name: breadcrumbParentCopy,
          url: checkValue(breadcrumbParentUrl) ? breadcrumbParentUrl : '#',
        });
      }
      items.push({
        active: true,
        name: checkValue(breadcrumbCurrentCopy) ? breadcrumbCurrentCopy : capitalizeFirst(pageSeoData?.feedName),
        url: '/' + pageSeoData?.partner + '/' + pageSeoData?.templateName + '/' + pageSeoData?.feedName,
      });
    }

    return items;
  };

  useEffect(() => {
    setCrumbs(getBreadcrumbs());
  }, []);

  if (!checkValue(crumbs)) return null;

  const getBreadCrumbItems = () => {
    return crumbs
      .map((crumb) => (
        <Cpds.BreadCrumbs.Item
          key={crumb?.name}
          itemCopy={crumb?.name}
          {...(checkValue(crumb?.url)
            ? {
                itemLink: crumb?.url,
              }
            : {})}
          itemTarget={checkValue(crumb?.target) ? crumb?.target : '_self'}
          active={crumb?.active}
          themeColorMode={theme}
          clickstreamData={clickstreamData}
        />
      ))
      .filter(Boolean);
  };

  return <Cpds.BreadCrumbs themeColorMode={theme} crumbs={getBreadCrumbItems()} />;
};

export default V3BreadcrumbModule;
